import axios from "axios";
import React, { Component, useEffect, useState } from 'react';
// import authService from './authService'
//import logger from "./logService";
import jwtDecode from 'jwt-decode';
import auth from './authService';
import swal from 'sweetalert';
//let  rights='';

axios.interceptors.response.use(null, async error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status <= 500;
  if (expectedError) {
    if (error.response.status == 403) {
      let res = await swal({
        title: "This account is logged in from another device.",
        text: "logout from this device",
        icon: "warning",
        button: "Logout!",
        closeOnEsc: false,
        closeOnClickOutside: false
      })
      if (res) {
        if (auth.getCurrentUser()) {
          window.location = '/'
          await auth.logout(auth.getCurrentUser().email);
          window.location = '/'
        } else {
          window.location = '/'
        }

      }

    }
  }


  if (!expectedError) {
    // alert("An unexpected error occurred.");
   // swal(`${error}`)
    //logger.log(error);
    //toast.error("An unexpected error occurred.");


  }



  return Promise.reject(error);
});

// function setDataRights(dataRightsKey)
// {
//      rights=dataRightsKey;
// }


function setJwt(jwt, company) {
  if (jwt !== null) {
    try {
      const data = jwt ? jwtDecode(jwt) : '';
      axios.defaults.headers.common["authorization"] = jwt;
      // axios.defaults.headers.common["rights"] = rights;
      if (data && data.Plants && data.Plants.length > 0) {
        axios.defaults.headers.common["Company"] = data ? (company || (data.Plants && data.Plants[0].company ? data.Plants[0].company : data.company)) : '';
      } else {
        axios.defaults.headers.common["Company"] = data?.company ? data.company : '';
      }
      axios.defaults.headers.common["Plant"] = data.Plants && data.Plants[0] ? data.Plants[0]._id : "";
      axios.defaults.headers.common["PlantName"] = data.Plants && data.Plants[0] ? data.Plants[0].groupName : "";
      axios.defaults.headers.common["id"] = data ? data._id : '';
      axios.defaults.headers.common["Name"] = data ? data.name : '';
      axios.defaults.headers.common["UserName"] = data ? data.email : '';
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = '*';
      // axios.defaults.headers.common["PlantName"] = data ?data.plants[0].plantName:'';
      return true
    }
    catch (e) {
      return false
    }



  }

}

export default {
  //get: axios.get,
  put: axios.put,
  post: axios.post,
  get: axios.get,
  delete: axios.delete,
  patch: axios.patch,
  setJwt,
  // setDataRights
};